import { LabelCombinedProps } from './types';

const usePresenter = (props: LabelCombinedProps): LabelCombinedProps => {
  return props;
};

export default usePresenter;
